import { NeoModel, ModelBase } from '@singularsystems/neo-core';
@NeoModel
export default class StaticClientEntityTypeLookup extends ModelBase {

    /// <summary>
    /// Gets or sets the client entity type ID.
    /// </summary>
    public clientEntityTypeId: number = 0;

    /// <summary>
    /// Gets or sets the client entity type name.
    /// </summary>
    public clientEntityTypeName: string = "";
}